import ServicesImageAbstract from "./ServicesImageAbstract";
import Math_ from "../../../../assets/src/js/app/utils/Math";

export default class ServicesImagesDevelopment extends ServicesImageAbstract {
	constructor($wrapper) {
		super($wrapper);
		this.rotation1 = 2;
		this.rotation2 = -2;
		this.init();
	}

	updateCanvas() {
		const velocity = this.velocity >= 0 ? Math_.clamp(this.velocity * 0.0003, 0.01, 0.1) : Math_.clamp(this.velocity * 0.0003, -0.1, -0.01);
		this.rotation1 -= velocity;
		this.rotation2 += velocity;
		// this.rotation1 += 0.1;
		// this.rotation2 -= 0.1;

		const blue = '#4545FF',
			opacity = 0.5,
			numShapes = 3,
			numSides = 6,
			sizes = [0.5, 0.3, 0.1];

		// RESET
		this.ctx.resetTransform();
		this.ctx.clearRect(0, 0, this.size, this.size);
		this.ctx.fillStyle = blue;
		this.ctx.globalAlpha = opacity;
		this.ctx.globalCompositeOperation = 'source-over';

		for (let i = 0; i < numShapes; i++) {

			// POLYGON
			const size = this.size * sizes[i],
				rotate = (i % 2 === 0 ? this.rotation2 * (1 - sizes[i]) : this.rotation1 * (1 - sizes[i])) * 0.3;
			this.ctx.resetTransform();
			this.ctx.translate(this.size * 0.5, this.size * 0.5);
			this.ctx.rotate(rotate);
			this.ctx.beginPath();
			this.ctx.moveTo(size * Math.cos(0), size * Math.sin(0));
			for (let j = 1; j <= numSides; j++) {
				this.ctx.lineTo(size * Math.cos(j * 2 * Math.PI / numSides), size * Math.sin(j * 2 * Math.PI / numSides));
			}
			this.ctx.fill();
		}

	}
}
